import { Component, Input, OnInit } from '@angular/core';
import { TimeOffPolicy } from '@app/modules/lookup/models/time-off-policy.model';
import { TimeOff } from '@app/modules/lookup/models/time-off.model';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { RefreshListener } from '@app/shared/models/refresh-listener';

@Component({
  selector: 'app-time-off-policies-types-editor',
  templateUrl: './time-off-policies-types-editor.component.html',
  styleUrls: ['./time-off-policies-types-editor.component.scss']
})
export class TimeOffPoliciesTypesEditorComponent implements OnInit, RefreshListener {
  @Input() timeOffTypeList: TimeOff[];
  @Input() timeOffType: TimeOff;
  @Input() policy: TimeOffPolicy;
  @Input() refreshListener: RefreshListener;
  @Input() currentCulture: Culture;

  public isCreatingPolicy = false;

  constructor() { }

  ngOnInit(): void {
  }

  openPolicyForm(policy: TimeOffPolicy) {
    this.isCreatingPolicy = false;
    this.policy = policy;
  }

  openNewPolicyForm() {
    this.policy = null;
    this.isCreatingPolicy = true;
  }

  closePolicyForm() {
    this.policy = null;
    this.isCreatingPolicy = false;
  }

  refresh(): void {
    this.closePolicyForm();
    this.refreshListener?.refresh?.();
  }

  cancel(): void {
    this.closePolicyForm();
    this.refreshListener?.cancel?.();
  }

  close(): void {
    this.closePolicyForm();
    this.refreshListener?.cancel?.();
  }

  deleteType(): void {
    this.refreshListener?.deleteType?.(this.timeOffType?.id);
  }
}
